import PeopleIcon from "@mui/icons-material/People";

// Central icon for students. Replace here to update everywhere.
export default PeopleIcon;
